import * as pc from "playcanvas";
var degreesToRadians = function (degrees) { return (degrees * Math.PI) / 180; };
/** Unit vector pointing from the model towards the camera for a view's angles. */
export var viewDirection = function (view) {
    var azimuth = degreesToRadians(view.azimuth);
    var elevation = degreesToRadians(view.elevation);
    return new pc.Vec3(Math.cos(elevation) * Math.sin(azimuth), Math.sin(elevation), Math.cos(elevation) * Math.cos(azimuth));
};
export var boundingBoxCorners = function (aabb) {
    var center = aabb.center, halfExtents = aabb.halfExtents;
    return [-1, 1].flatMap(function (x) {
        return [-1, 1].flatMap(function (y) {
            return [-1, 1].map(function (z) {
                return new pc.Vec3(center.x + x * halfExtents.x, center.y + y * halfExtents.y, center.z + z * halfExtents.z);
            });
        });
    });
};
/**
 * The distance from the box's centre, along `direction`, at which a square
 * perspective camera with the given vertical field of view sees the whole box.
 * Each corner needs the camera far enough back that its sideways offset fits
 * inside the frustum at the corner's depth, so the result is the largest such
 * distance over all eight corners. `margin` scales it: 1 fits edge to edge.
 */
export var fitDistance = function (aabb, direction, fovDegrees, margin) {
    var towardsCamera = direction.clone().normalize();
    var forward = towardsCamera.clone().mulScalar(-1);
    var worldUp = Math.abs(forward.y) > 0.999 ? pc.Vec3.FORWARD : pc.Vec3.UP;
    var right = new pc.Vec3().cross(forward, worldUp).normalize();
    var up = new pc.Vec3().cross(right, forward).normalize();
    var tanHalfFov = Math.tan(degreesToRadians(fovDegrees) / 2);
    var distance = boundingBoxCorners(aabb).reduce(function (needed, corner) {
        var offset = corner.sub(aabb.center);
        var lateral = Math.max(Math.abs(offset.dot(right)), Math.abs(offset.dot(up)));
        return Math.max(needed, lateral / tanHalfFov + offset.dot(towardsCamera));
    }, 0);
    return distance * margin;
};
